export default __webpack_public_path__ + "static/media/LECLERC_03.adee1b09.gif";